module.exports = __webpack_public_path__ + "static/media/fondo-mapeala.16d1b388.jpg";